var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_602",
    "data-name": "Group 602",
    transform: "translate(15735.5 702.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_172",
    "data-name": "Rectangle 172",
    transform: "translate(-15735.5 -702.5)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_905",
    "data-name": "Path 905",
    d: "M71.306,122.808l-2.745,27.564H35.591l-2.212-27.031,18.7,10.468Z",
    transform: "translate(-15762.076 -809.85)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_906",
    "data-name": "Path 906",
    d: "M74.712,60.983l-18.3,17.19-18.3-17.19h36.6Z",
    transform: "translate(-15766.413 -753.217)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_902",
    "data-name": "Path 902",
    d: "M5.015,115.623v24.819H2.027A2.028,2.028,0,0,1,0,138.415V111.967l3.275.089Z",
    transform: "translate(-15731.5 -799.919)",
    fill: "#f14336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_907",
    "data-name": "Path 907",
    d: "M457.3,109.22v26.448a2.028,2.028,0,0,1-2.028,2.027h-2.986V112.875l1.654-3.907Z",
    transform: "translate(-16145.803 -797.172)",
    fill: "#d32e2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_903",
    "data-name": "Path 903",
    d: "M43,63.01v2.255L37.985,68.92,21.5,80.936,5.015,68.92,0,65.265V63.01a2.028,2.028,0,0,1,2.027-2.027H3.2L21.5,74.32,39.8,60.983h1.173A2.028,2.028,0,0,1,43,63.01Z",
    transform: "translate(-15731.5 -753.217)",
    fill: "#f14336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_904",
    "data-name": "Path 904",
    d: "M5.015,115.623,0,114.845v-2.878Z",
    transform: "translate(-15731.5 -799.919)",
    fill: "#d32e2a"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.8dc11941eb4711097672e4f2de8be5b3.svg";
export { ForwardRef as ReactComponent };